import type { ReactNode } from 'react';
import { ShimmerText } from '@cotera/client/v0/components/ui/shimmer-text';
import { cn } from '@cotera/client/v0/lib/utils';

type RunningToolTitleProps = {
  children: ReactNode;
  /** Extra classes (e.g. min-w-0 for flex shrink). */
  className?: string;
};

/**
 * Shimmer label for tool / sub-agent header rows while work is in flight.
 */
export function RunningToolTitle({
  children,
  className,
}: RunningToolTitleProps) {
  return (
    <ShimmerText variant="muted" className={cn(className)}>
      {children}
    </ShimmerText>
  );
}
